import { Button } from "@chakra-ui/button";
import {
  Center,
  Flex,
  Grid,
  GridItem,
  Heading,
  Stack,
  Text
} from "@chakra-ui/layout";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Code,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightAddon,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure
} from "@chakra-ui/react";


import Tweets from "components/tweets";

import { useRouter } from "next/dist/client/router";
import React, { useEffect } from "react";

import { AddIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { useSession } from "next-auth/client";

import { EditIcon } from "@chakra-ui/icons";
import { UpsertCollection } from "components/collection-upsert";
import { CustomAi } from "components/collections/customai";
import { Evergreen } from "components/collections/evergreen";
import { DeleteIcon } from "components/icons/DeleteIcon";
import { ImportIcon } from "components/icons/ImportIcon";
import { Page } from "components/page";
import { ImportTweet } from "components/popups/importTweet";
import ProtectedRoute from "components/protected-route";
import { deleteList, getList } from "controllers/bookmark";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { BiCopy } from "react-icons/bi";
import PuffLoader from "react-spinners/PuffLoader";
import * as analytics from "../utils/analytics";
import { setInLocalStorage } from "../utils/helpers";
import { getAccount } from "../utils/sessionHelper";
import { useFirebaseUser } from "../utils/useFirebaseUser";



let tabs = ["collections", "evergreen", "customai"];

const Collections = ({ query }) => {
  const [session, loading] = useSession();
  const router = useRouter();
  const isAuthenticated = useFirebaseUser();
  const [savedTweet, setSavedTweet] = React.useState([]);
  const [tweets, setTweets] = React.useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isOpenShare,
    onOpen: onOpenShare,
    onClose: onCloseShare,
  } = useDisclosure();
  const initialRef = React.useRef<any>();

  const [refresh, refresher] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedListId, setSelectedListId] = React.useState(0);
  const [tabId, setTabId] = React.useState(0);
  const [lists, setLists] = React.useState<any[]>([]);
  const [firstLoadDone, setFirstLoadDone] = React.useState(false);
  const cancelRef = React.useRef() as React.MutableRefObject<HTMLButtonElement>;
  const [isOpenDelete, setIsOpenDelete] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const onCloseDelete = () => setIsOpenDelete(false);

  //@ts-ignore
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [isUpdate, setIsUpdate] = React.useState(false);

  const refreshPage = async () => {
    // await mutate("/api/auth/session");
    refresher({});
  };

  const getSavedTweets = async () => {
    // console.log("getSavedTweets");
    // console.log(loading);
    if (isAuthenticated) {
      setIsLoading(true);
      //@ts-ignore
      const resTweets = await getList(
        getAccount(session).id,
        selectedListId,
        false
      );
      //@ts-ignore
      // const ids = savedTweets.map((tweet) => tweet.id_str);
      setTweets(resTweets);

      //@ts-ignore
      setSavedTweet(resTweets);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // console.log("useEffect");
    if (isAuthenticated) {
      // console.log("lists: " + getAccount(session).lists);
      setLists(getAccount(session).lists);
    }
  }, [refresh, session, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && tabId == 0) {
      getSavedTweets();
    }
  }, [refresh, selectedListId]);

  const changeTabFromQuery = (query) => {
    if (query.tab) {
      let match = tabs.find((x) => x == query.tab);
      if (match) {
        let index = tabs.indexOf(match);
        setTabId(index);
      }
    }
  };

  useEffect(() => {
    changeTabFromQuery(query);
  }, []);

  useEffect(() => {
    changeTabFromQuery(query);
  }, [query.tab]);

  useEffect(() => {
    if (isAuthenticated && !firstLoadDone) {
      setFirstLoadDone(true);
      if (tabId == 0) {
        loadPersonalCollections();
      }
    }
  }, [session, isAuthenticated]);

  const loadPersonalCollections = () => {
    getSavedTweets();
    analytics.log("load_personal_collections");
  };

  let publicUrl =
    selectedListId !== undefined
      ? "https://tweethunter.io/collection?id=" +
      getAccount(session)?.id +
      "&idList=" +
      selectedListId +
      "&list=" +
      encodeURIComponent(
        getAccount(session)?.lists.find((x) => x.id === selectedListId)?.name
      ) +
      "&handle=" +
      getAccount(session)?.twUserName
      : "";

  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <Page title="Collections">
      <Tabs
        // variant="line"
        index={tabId}
        onChange={(index) => {
          if (index == 0) {
            loadPersonalCollections();
          }
          setInLocalStorage("collectionTabId", "" + index);
          setTabId(index);
          router.push(
            {
              pathname: "/collections",
              query: { tab: tabs[index] },
            },
            undefined,
            { shallow: false }
          );
        }}
      >
        <TabList mt={4} mb={4} p={0}>
          <Tab>
            My Collections
          </Tab>
          <Tab>
            Evergreen
          </Tab>
          <Tab>
            Custom AI
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel px="0">
            <Grid
              mt={4}
              mb={10}
              // templateRows="repeat(2, 1fr)"
              // templateColumns="repeat(6, 1fr)"
              // templateColumns="repeat(1, 1fr)"
              templateColumns={{ md: "repeat(6, 1fr)", sm: "repeat(3, 1fr)" }}
              // templateColumns={{sm: 2, md: 2}}
              columnGap="0"
              rowGap={5}
            >
              <GridItem colSpan={3} display="flex" alignItems="center">
                <Menu isLazy>
                  <MenuButton
                    as={Button}
                    // size="sm"
                    variant={"secondary"}
                    rightIcon={<ChevronDownIcon />}
                  >
                    <Text noOfLines={1} wordBreak="break-all">
                      {!selectedListId
                        ? "All my saved tweets"
                        : lists.find((l) => l.id == selectedListId)?.name}
                    </Text>
                  </MenuButton>
                  <MenuList maxH="215px" overflow="scroll">
                    <MenuItem
                      // width="100%"
                      // justifyContent="space-between"
                      // alignItems="center"
                      // cursor="default"
                      onClick={(e) => setSelectedListId(0)}
                    >
                      <Text
                      // width="90%"
                      >
                        All my saved tweets
                      </Text>
                    </MenuItem>
                    {lists?.length > 0 ? (
                      lists.map((list, index) => (
                        <MenuItem
                          // width="100%"
                          // justifyContent="space-between"
                          // alignItems="center"
                          // cursor="default"
                          key={index}
                          onClick={(e) => setSelectedListId(parseInt(list.id))}
                        >
                          <Text
                          // width="90%"
                          >
                            {list.name}
                          </Text>
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem
                      // width="100%"
                      // justifyContent="space-between"
                      // alignItems="center"
                      // cursor="default"
                      >
                        <Text>No List found</Text>
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
                <IconButton
                  aria-label="update-collection"
                  variant="secondary"
                  ml={2}
                  // size="md"
                  onClick={async () => {
                    setIsUpdate(false);
                    onEditOpen();
                  }}
                  icon={<AddIcon />}
                  mr={0}
                />
                {selectedListId && selectedListId > 0 ? (
                  <>
                    <IconButton
                      aria-label="update-collection"
                      variant="secondary"
                      ml={2}
                      // variant="tertiary"
                      // size="md"
                      onClick={async () => {
                        setIsUpdate(true);
                        onEditOpen();
                      }}
                      icon={<EditIcon />}
                      mr={0}
                    />
                    <IconButton
                      aria-label="update-collection"
                      variant="secondary"
                      ml={2}
                      // variant="tertiary"
                      // size="md"
                      onClick={async () => {
                        setIsOpenDelete(true);
                      }}
                      icon={DeleteIcon}
                      mr={1}
                    />
                  </>
                ) : (
                  <></>
                )}
              </GridItem>
              <GridItem
                colSpan={3}
                display="flex"
                justifyContent={{ md: "flex-end", sm: "flex-start" }}
              >
                <Button
                  variant="secondary"
                  mt={1}
                  ml={0}
                  onClick={onOpen}
                  isDisabled={selectedListId === 0} // dont allow imports in "Allow my saved posts" menu. It is suppose to just show posts from all collections
                  leftIcon={ImportIcon}
                >
                  Import Tweets
                </Button>
                {isAuthenticated && (
                  <CopyToClipboard
                    text={publicUrl}
                    onCopy={() => {
                      toast.success("Public URL copied to clipboard", {
                        style: {
                          background: "gray.600",
                          color: "#222",
                        },
                      });
                    }}
                  >
                    <Button
                      mt={1}
                      ml={4}
                      onClick={(e) => {
                        onOpenShare();
                      }}
                      variant={"primary"}
                    >
                      Share Public Url
                    </Button>
                  </CopyToClipboard>
                )}
              </GridItem>
            </Grid>
            <Stack>
              {isLoading ? (
                <Center pt={10}>
                  <PuffLoader
                    color={"hsl(203, 100%, 36%)"}
                    loading={isLoading}
                    css="display: block; margin: 0 auto; border-color: red;"
                    size={50}
                  />
                </Center>
              ) : tweets?.length > 0 && !loading ? (
                <Tweets
                  savedTweet={savedTweet}
                  tweets={tweets}
                  refresher={refreshPage}
                  refresh={refresh}
                  disableHideButton={true}
                  //@ts-ignore
                  embedData={{
                    id: getAccount(session).id,
                    idList: selectedListId,
                  }}
                  disableTweetCount={false}
                  header={
                    selectedListId && selectedListId > 0 ? (
                      <>
                        Reply "
                        <b>
                          @TweetHunterIO save in{" "}
                          {lists?.find((l) => l.id == selectedListId)?.name}
                        </b>
                        " to save a tweet in this collection directly from
                        Twitter
                      </>
                    ) : (
                      ""
                    )
                  }
                />
              ) : (
                <Flex mt={12} flexDir={"column"} alignItems={"center"}>
                  {/* <SaveIconComponent {...{ width: 48, height: 48 }} /> */}
                  <svg
                    width="64"
                    height="56"
                    viewBox="0 0 64 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M56 8C60.375 8 64 11.625 64 16V48C64 52.5 60.375 56 56 56H8C3.5 56 0 52.5 0 48V8C0 3.625 3.5 0 8 0H22.625C24.75 0 26.75 0.875 28.25 2.375L34.375 8H56ZM58 48V16C58 15 57 14 56 14H52V34C52 35.75 50 36.625 48.75 35.625L42 30.25L35.125 35.5C33.875 36.5 32 35.625 32 34V14L24 6.625C23.625 6.25 23.125 6 22.625 6H8C6.875 6 6 7 6 8V48C6 49.125 6.875 50 8 50H56C57 50 58 49.125 58 48Z"
                      fill="#98A1AC"
                    />
                  </svg>
                  <Text textStyle="body.medium.standard" mt={8} fontSize={"lg"}>
                    No tweets have been found
                  </Text>
                  <Text
                    textStyle="body.medium.light"
                    mt={4}
                    fontSize={"lg"}
                    maxW={"lg"}
                    lineHeight={1.6}
                    textAlign={"center"}
                  >
                    You haven't saved any tweets yet. Save tweets from your
                    searches on TweetHunter and they will appear here.
                  </Text>
                  {/* <Flex textStyle="body.medium.light" flexDir={"column"} alignItems={"center"} gap={8}> */}
                  {/* <Text
                            textAlign="center"
                            // fontSize="xl"
                            // fontWeight={500}
                              maxW={350}
                              textStyle="h3.bold.standard"
                          >
                            You haven't saved any tweets yet.
                            Save tweets from your
                            searches on TweetHunter and they will appear here.
                          </Text> */}
                  {/* <Text textAlign="center" fontSize={30}>
                            💾
                          </Text> */}

                  {/* </Flex> */}
                </Flex>
              )}
            </Stack>
          </TabPanel>
          <TabPanel px="0">
            <Evergreen />
          </TabPanel>
          <TabPanel px="0">
            <CustomAi />
          </TabPanel>
        </TabPanels>
      </Tabs>
      <ImportTweet
        isOpen={isOpen}
        onClose={onClose}
        refresher={refresher}
        selectedListId={selectedListId}
      />
      {
        // selectedListId ? (
        true ? (
          <UpsertCollection
            isUpdate={isUpdate}
            id={selectedListId}
            name={
              getAccount(session)?.lists.find((x) => x.id === selectedListId)
                ?.name
            }
            isOpen={isEditOpen}
            onClose={onEditClose}
            refresher={refreshPage}
          />
        ) : (
          <></>
        )
      }
      <AlertDialog
        isOpen={isOpenDelete}
        //@ts-ignore
        leastDestructiveRef={cancelRef}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Collection
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                variant="tertiary"
                ref={cancelRef}
                onClick={onCloseDelete}
              >
                Cancel
              </Button>
              <Button
                variant="secondaryDestructive"
                onClick={async () => {
                  setIsDeleting(true);
                  await deleteList(
                    getAccount(session).id,
                    selectedListId,
                    session
                  );
                  refresher({});
                  setSelectedListId(0);
                  // await mutate("/api/auth/session");
                  onCloseDelete();
                  setIsDeleting(false);
                }}
                ml={3}
                isLoading={isDeleting}
                leftIcon={DeleteIcon}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <Modal
        initialFocusRef={initialRef}
        isOpen={isOpenShare}
        onClose={onCloseShare}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Share your collection</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Your custom link</FormLabel>
              <InputGroup size="md">
                <Input ref={initialRef} isDisabled value={publicUrl} />
                <InputRightAddon
                  p={0}
                  children={
                    <CopyToClipboard
                      text={publicUrl}
                      onCopy={() => {
                        toast.success("Public URL copied to clipboard", {
                          style: {
                            background: "gray.600",
                            color: "#222",
                          },
                        });
                      }}
                    >
                      <IconButton
                        aria-label="Search database"
                        _focus={{ boxShadow: "none" }}
                        size="md"
                        variant="tertiary"
                        icon={<BiCopy />}
                      />
                    </CopyToClipboard>
                  }
                />
              </InputGroup>
            </FormControl>
            <Heading mt={8} size="small">
              Want to earn money by sharing it?
            </Heading>
            <Text mt={3}>
              Join our{" "}
              <Link
                href="https://affiliates.tweethunter.io/"
                color="teal.500"
                isExternal
              >
                Referral Program
              </Link>{" "}
              and append this collection url with your custom parameter.
            </Text>
            <Text mt={3}>
              It should look like this:
              <Code as="span" ml={2} mr={2}>
                {"&via=YOUR_REFERRAL_ID"}
              </Code>
            </Text>
            <Text mt={3}>
              You will receive a <b>30% commission</b> everytime a user you
              referred makes a payment, forever.
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Page>
  );
};

Collections.getInitialProps = async ({ query }) => {
  // console.log(query);
  return { query };
};

export default Collections;
